
// Header.js
import React, { useState } from "react";
import '../style/style.css';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = ({ handleDrawerToggle, headerWidth }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate()

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const logOut = ()=>{
    localStorage.removeItem('jwt')
    navigate('/public')
    toast.success('Logout Successfully')
  }

  return (
    <AppBar position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,  
        width: { md: `calc(100% - ${headerWidth})`},  
      }}
    >
      <Toolbar>
        <IconButton
          color="black"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ 
            mr: 2, 
            display: { sm: "none" },            
          }}
        >
          <MenuIcon />
        </IconButton>
                
        <Typography            
          variant="h6" 
          noWrap 
          component="div" 
          sx={{ flexGrow: 1, textAlign: 'center', color:"black"  }}
        >
          Spinner Admin
        </Typography>
        
        <IconButton color="black" onClick={handleProfileMenuOpen}>
          <AccountCircle />
        </IconButton>
        
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleProfileMenuClose}
        >
          <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
          <MenuItem onClick={handleProfileMenuClose}>Settings</MenuItem>
          <MenuItem onClick={()=>logOut()}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;


// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Menu,
//   MenuItem,
//   Box,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import AccountCircle from "@mui/icons-material/AccountCircle";

// const Header = ({ handleDrawerToggle }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [isIconOnly, setIsIconOnly] = useState(false);

//   const handleProfileMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleProfileMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleDesktopMenuToggle = () => {
//     setIsIconOnly(!isIconOnly);
//     handleDrawerToggle();
//   };

//   return (
//     <AppBar 
//       position="fixed" 
//       sx={{ 
//         zIndex: (theme) => theme.zIndex.drawer + 1,
//         width: { 
//           xs: '100%',
//           sm: isIconOnly ? '100%' : `calc(100% - 240px)`
//         },
//         transition: 'width 0.3s ease-in-out'
//       }}
//     >
//       <Toolbar>
//         {/* Mobile hamburger menu */}
//         <IconButton
//           color="inherit"
//           aria-label="open drawer"
//           edge="start"
//           onClick={handleDrawerToggle}
//           sx={{ 
//             mr: 2, 
//             display: { xs: 'block', sm: 'none' }
//           }}
//         >
//           <MenuIcon />
//         </IconButton>

//         {/* Desktop hamburger menu */}
//         <IconButton
//           color="inherit"
//           aria-label="toggle desktop menu"
//           edge="start"
//           onClick={handleDesktopMenuToggle}
//           sx={{ 
//             mr: 2, 
//             display: { xs: 'none', sm: 'block' }
//           }}
//         >
//           <MenuIcon />
//         </IconButton>
        
//         <Typography 
//           variant="h6" 
//           noWrap 
//           component="div" 
//           sx={{ 
//             flexGrow: 1,
//             ml: { sm: isIconOnly ? 0 : 2 }
//           }}
//         >
//           Responsive App
//         </Typography>
        
//         <IconButton color="inherit" onClick={handleProfileMenuOpen}>
//           <AccountCircle />
//         </IconButton>
        
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleProfileMenuClose}
//         >
//           <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
//           <MenuItem onClick={handleProfileMenuClose}>Settings</MenuItem>
//           <MenuItem onClick={handleProfileMenuClose}>Logout</MenuItem>
//         </Menu>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Header;